import React from 'react';
import { FileTextIcon } from 'lucide-react';
export function KSeriesSection() {
  return <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-716">
      <div className="bg-[#002d4d] text-white py-6 px-8 flex flex-col md:flex-row md:items-center justify-between" data-id="element-717">
        <div data-id="element-718">
          <h2 className="text-3xl font-bold mb-1" data-id="element-719">Bodor K Series</h2>
          <h3 className="text-white/80 font-medium text-lg" data-id="element-720">
            Economical Fiber Laser Tube Cutting Machine
          </h3>
        </div>
      </div>

      <div className="p-8" data-id="element-721">
        <div className="grid md:grid-cols-12 gap-12 items-center mb-10" data-id="element-722">
          <div className="md:col-span-5 flex flex-col items-center bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-723">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/BODOR/Laser%20Tube%20Cutter/Bodor%20K%20Series%20Laser%20Tube%20Cutting%20Machine.PNG" alt="Bodor K Series" className="block max-h-[350px] w-auto object-contain drop-shadow-xl mb-4" data-id="element-724" />
            <span className="bg-[#f5693d] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider text-center" data-id="element-725">
              Small and Smart Tube Laser Cutting Machine
            </span>
          </div>
          <div className="md:col-span-7" data-id="element-726">
            <ul className="space-y-4 text-gray-700" data-id="element-727">
              <li data-id="element-728">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-729">
                  Integrated Full Protection Cover
                </strong>
              </li>
              <li data-id="element-730">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-731">
                  Bodor Genius T needle nose auto-focusing laser head
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-732">
                  Applicable for all kinds of tubes such as angle steel, channel
                  steel, I-beam, etc.
                </span>
              </li>
              <li data-id="element-733">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-734">
                  Rectangular Tube Welded Bed
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-735">
                  Simple structure with flexible layout
                </span>
              </li>
              <li data-id="element-736">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-737">
                  Bodor Thinker 3.0 System
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-738">
                  The dedicated control system of tube cutting machine
                  integrated with the most advanced technology, can cut angle
                  steel and channel steel directly without nesting and returning
                  home.
                </span>
              </li>
              <li data-id="element-739">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-740">
                  Applicable to smaller clamping diameter
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-741">
                  The rear jaws can clamp the pipe to go through the front
                  chuck, which greatly shortens the physical distance between
                  the cutting head and the rear chuck jaws. Tail length is
                  reduced to 70mm and the material utilization rate is increased
                  to 99%.
                </span>
              </li>
              <li data-id="element-742">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-743">
                  Ergonomics
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-744">
                  Loading and operating on both sides; and humanized interaction
                  interface, convenient and smooth operation, and favorable user
                  experience.
                </span>
              </li>
              <li data-id="element-745">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-746">
                  Integrated Design
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-747">
                  Integrated design of electric control cabinet and main body,
                  saving the space occupied, standardizing the line
                  installation.
                </span>
              </li>
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 mt-8 pt-6 border-t border-gray-100" data-id="element-748">
              <a href="https://www.peakedm.com/m7/Bodor%20T%20Series--t-series-performance-fiber-laser-tube-cutting-machine.html" className="inline-flex items-center justify-center px-6 py-3 bg-[#002d4d] text-white font-bold uppercase text-sm rounded-md hover:bg-[#f5693d] transition-colors" data-id="element-749">
                <span className="mr-2" data-id="element-750">+</span> Discover More
              </a>
              <a href="https://www.peakedm.com/uploaded/files/Bodor%20Files/Brochure%20Bodor%20T%20series%20Fiber%20Laser%20Tube%20Cutter.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-[#002d4d] text-[#002d4d] font-bold uppercase text-sm rounded-md hover:bg-[#002d4d] hover:text-white transition-colors" data-id="element-751">
                <FileTextIcon className="w-4 h-4 mr-2" data-id="element-752" /> Download Brochure
              </a>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm" data-id="element-753">
          <table className="w-full text-sm text-left text-gray-600" data-id="element-754">
            <thead className="text-xs text-gray-700 uppercase bg-gray-100 border-b border-gray-200" data-id="element-755">
              <tr data-id="element-756">
                <th scope="col" className="px-6 py-4 font-bold border-r border-gray-200 w-1/4" data-id="element-757">
                  Model
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center border-r border-gray-200 w-1/4" data-id="element-758">
                  K110
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center border-r border-gray-200 w-1/4" data-id="element-759">
                  K230
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center w-1/4" data-id="element-760">
                  K360
                </th>
              </tr>
            </thead>
            <tbody data-id="element-761">
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-762">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-763">
                  Working Area
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-764">
                  8649×1398×1811mm
                </td>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-765">
                  8800×3200×2100mm
                </td>
                <td className="px-6 py-4 text-center" data-id="element-766">10000×3500×2100mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-767">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-768">
                  Laser Power
                </th>
                <td colSpan={3} className="px-6 py-4 text-center" data-id="element-769">
                  3000w/2000w/1500w/1000w (K110, K230)
                </td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-770">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-771">
                  Positioning accuracy
                </th>
                <td colSpan={3} className="px-6 py-4 text-center" data-id="element-772">
                  0.05mm
                </td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-773">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-774">
                  Repositioning accuracy
                </th>
                <td colSpan={3} className="px-6 py-4 text-center" data-id="element-775">
                  0.03mm
                </td>
              </tr>
              <tr className="bg-white hover:bg-gray-50" data-id="element-776">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-777">
                  Max. linkage speed
                </th>
                <td colSpan={3} className="px-6 py-4 text-center" data-id="element-778">
                  60m/min
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}